function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLandingPlans5 = function SvgLandingPlans5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18202_16798)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 24,
    fill: "#00D061"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0348 19.7028C20.668 21.0696 20.668 23.2695 20.668 27.6693V32.3359C20.668 36.7357 20.668 38.9356 22.0348 40.3024C23.4016 41.6693 25.6015 41.6693 30.0013 41.6693C34.4011 41.6693 36.601 41.6693 37.9678 40.3024C39.3346 38.9356 39.3346 36.7357 39.3346 32.3359V27.6693C39.3346 23.2695 39.3346 21.0696 37.9678 19.7028C36.601 18.3359 34.4011 18.3359 30.0013 18.3359C25.6015 18.3359 23.4016 18.3359 22.0348 19.7028ZM26.5013 20.9609C26.0181 20.9609 25.6263 21.3527 25.6263 21.8359C25.6263 22.3192 26.0181 22.7109 26.5013 22.7109H33.5013C33.9846 22.7109 34.3763 22.3192 34.3763 21.8359C34.3763 21.3527 33.9846 20.9609 33.5013 20.9609H26.5013ZM30.0013 38.1693C31.29 38.1693 32.3346 37.1246 32.3346 35.8359C32.3346 34.5473 31.29 33.5026 30.0013 33.5026C28.7126 33.5026 27.668 34.5473 27.668 35.8359C27.668 37.1246 28.7126 38.1693 30.0013 38.1693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter0_dii_18202_16798)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.289062,
    width: 62.7024,
    height: 62.0133,
    rx: 24,
    transform: "rotate(-0.27563 0 0.289062)",
    fill: "url(#paint0_linear_18202_16798)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_18202_16798",
    x: -4.42874,
    y: -3.7916,
    width: 78.9949,
    height: 76.3609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.54202,
    dy: 3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18202_16798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_18202_16798",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.54202,
    dy: 3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_18202_16798"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.54202,
    dy: -3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_18202_16798",
    result: "effect3_innerShadow_18202_16798"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18202_16798",
    x1: 10.8965,
    y1: 7.85166,
    x2: 52.6412,
    y2: 53.4981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18202_16798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 24,
    fill: "white"
  }))));
};
export default SvgLandingPlans5;